import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PARTS, SALES, TECHNICIAN } from 'constants/ModeConstants';

export const FOLLOW_DASHBOARD_SOURCE = 'dashboard-source';

export const ENABLE_MODES = [TECHNICIAN, SALES, PARTS];

export const FOLLOW_UP_STATUS = {
  NOT_PLANNED: 'NOT_PLANNED',
  PLANNED: 'PLANNED',
  SENT: 'SENT',
  ANSWERED: 'ANSWERED',
};

export const FOLLOW_UP_STATUSES = Object.values(FOLLOW_UP_STATUS);

export const FOLLOW_UP_LABEL = {
  [FOLLOW_UP_STATUS.NOT_PLANNED]: <FormattedMessage id="page.fiche.followUp.status.NOT_PLANNED" defaultMessage="Not planned" />,
  [FOLLOW_UP_STATUS.PLANNED]: <FormattedMessage id="customSteps.fixedStep.description.planned" defaultMessage="Planned" />,
  [FOLLOW_UP_STATUS.SENT]: <FormattedMessage id="intervention_status.sent" defaultMessage="Sent" />,
  [FOLLOW_UP_STATUS.ANSWERED]: <FormattedMessage id="answered" defaultMessage="Answered" />,
};
